import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base-service';

interface CastometreSettingsDto {
  enabled: boolean;
  appStoreUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class CastometreService extends BaseService {

  public get apiUrl() {
    return environment.configurators2d.baseApi + 'Castometre/';
  }

  public enabled: boolean = false;
  public appStoreUrl: string = '';

  constructor() {
    super();
    this.initSettings().then();
  }

  private async initSettings(): Promise<void> {
    const settings = await this.get<CastometreSettingsDto>(this.apiUrl + 'Settings');
    this.enabled = settings.enabled;
    this.appStoreUrl = settings.appStoreUrl ?? '';
  }
}
